import type { Delta, DeltaOperation, StringMap } from 'quill';

const parseDelta = (delta: Delta) =>
  createOutterElement(replaceNewLines(delta.ops?.map(parseOp).reduce((a, b) => a + b) ?? ''));

const createOutterElement = (children: string) => `<p>${children}</p>`;

const parseOp = (op: DeltaOperation) => {
  if (op.insert) {
    return parseInsert(op.insert, op.attributes);
  }
  return '';
};

const replaceNewLines = (children: string) => children.replace(/\n/g, '<br>');

const parseInsert: any = (insert: any, attributes?: StringMap) => {
  if (attributes?.bold) {
    const attr = { ...attributes, bold: false };
    return b(parseInsert(insert, attr));
  }

  if (attributes?.italic) {
    const attr = { ...attributes, italic: false };
    return i(parseInsert(insert, attr));
  }

  if (attributes?.underline) {
    const attr = { ...attributes, underline: false };
    return u(parseInsert(insert, attr));
  }

  if (attributes?.link) {
    const attr = { ...attributes, link: false };
    return link(attributes.link, parseInsert(insert, attr));
  }

  return textOrBlot(insert);
};

const b = (children: string) => `<b>${children}</b>`;

const i = (children: string) => `<i>${children}</i>`;

const u = (children: string) => `<u>${children}</u>`;

const link = (url: string, children: string) => `<a href="${url}">${children}</a>`;

const textOrBlot = (insert: any) => {
  if (typeof insert === 'string') {
    return insert as string;
  }
  if (insert.mention) {
    return `{${insert.mention.id}}`;
  }

  return '';
};

export default parseDelta;
